exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/manage/flag-ticket-treshold-count/flag-ticket-treshold-count.component.css
// module id = 590
// module chunks = 0